module.exports = __webpack_public_path__ + "img/tsinghua_anniversary-20160423-2-1024x768.2d0e0689.jpg";